import React from "react";
import PropTypes from "prop-types";
import ConnectedP2PInjectionHead from "./common/ConnectedP2PInjectionHead";
import ConnectedP2PInjectionBody from "./common/ConnectedP2PInjectionBody";

const Injections = ({ appLoading }) =>
    !appLoading && (
        <>
            {/* Injections that are made into the document head via React Helmet  */}
            <ConnectedP2PInjectionHead />
            {/* Injections that are inserted into #injection-container */}
            <ConnectedP2PInjectionBody />
        </>
    );

Injections.propTypes = {
    appLoading: PropTypes.bool.isRequired,
};

export default Injections;
